import {
    CalendarDays,
    User,
    Store,
    Bike,
    MapPin,
    CreditCard,
    IndianRupee,
    Package,
    Receipt,
} from "lucide-react";

import "./OrderHero.css";

function OrderHero({ order }) {

    const totalItems =
        order.items?.reduce(
            (sum, item) => sum + item.quantity,
            0
        ) || 0;

    return (

        <div className="order-hero">

            {/* ================= HEADER ================= */}

            <div className="order-hero-top">

                <div>

                    <div className="order-number">

                        <h1>

                            Order #{order.orderNumber}

                        </h1>

                        <span className="invoice-number">

                            <Receipt size={15} />

                            Invoice :
                            {" "}
                            {order.invoiceNumber || "Not Generated"}

                        </span>

                    </div>

                    <p className="order-date">

                        <CalendarDays size={16} />

                        {new Date(order.createdAt).toLocaleString(
                            "en-IN",
                            {
                                dateStyle: "full",
                                timeStyle: "short",
                            }
                        )}

                    </p>

                </div>

                <span
                    className={`hero-status status-${order.status
                        ?.toLowerCase()
                        .replace(/\s+/g, "-")}`}
                >

                    {order.status}

                </span>

            </div>

            {/* ================= SUMMARY ================= */}

            <div className="order-hero-grid">

                {/* Customer */}

                <div className="hero-card">

                    <User size={24} />

                    <div>

                        <label>Customer</label>

                        <h4>

                            {order.customerSnapshot?.name ||
                                "Not Available"}

                        </h4>

                        <span>

                            {order.customerSnapshot?.phone ||
                                "-"}

                        </span>

                        <small>

                            {order.customerSnapshot?.email ||
                                "-"}

                        </small>

                    </div>

                </div>

                {/* Provider */}

                <div className="hero-card">

                    <Store size={24} />

                    <div>

                        <label>Provider</label>

                        <h4>

                            {order.providerSnapshot
                                ?.businessName ||
                                "-"}

                        </h4>

                        <span>

                            {order.providerSnapshot?.phone ||
                                "-"}

                        </span>

                        <small>

                            {order.providerSnapshot?.email ||
                                "-"}

                        </small>

                    </div>

                </div>

                {/* Delivery */}

                <div className="hero-card">

                    <Bike size={24} />

                    <div>

                        <label>Delivery Partner</label>

                        <h4>

                            {order.deliverySnapshot?.name ||
                                "Not Assigned"}

                        </h4>

                        <span>

                            {order.deliverySnapshot?.phone ||
                                "Waiting for assignment"}

                        </span>

                        <small>

                            Vehicle :

                            {" "}

                            {order.deliverySnapshot
                                ?.vehicleNumber ||
                                "-"}

                        </small>

                    </div>

                </div>

                {/* Payment */}

                <div className="hero-card">

                    <CreditCard size={24} />

                    <div>

                        <label>Payment</label>

                        <h4>

                            {order.paymentStatus}

                        </h4>

                        <span>

                            {order.paymentMethod}

                        </span>

                        <small>

                            Payment ID :

                            {" "}

                            {order.paymentId ||
                                "N/A"}

                        </small>

                    </div>

                </div>

                {/* Amount */}

                <div className="hero-card">

                    <IndianRupee size={24} />

                    <div>

                        <label>Grand Total</label>

                        <h4>

                            ₹

                            {Number(
                                order.grandTotal || 0
                            ).toLocaleString("en-IN")}

                        </h4>

                        <span>

                            Delivery :

                            ₹

                            {order.deliveryCharge}

                        </span>

                        <small>

                            GST :

                            ₹

                            {order.gst}

                        </small>

                    </div>

                </div>

                {/* Items */}

                <div className="hero-card">

                    <Package size={24} />

                    <div>

                        <label>Order Items</label>

                        <h4>

                            {totalItems}

                        </h4>

                        <span>

                            {order.items?.length || 0}

                            {" "}

                            Different Foods

                        </span>

                        <small>

                            Coupon :

                            {" "}

                            {order.couponCode ||
                                "None"}

                        </small>

                    </div>

                </div>

            </div>

            {/* ================= ADDRESS ================= */}

            <div className="order-address">

                <MapPin size={20} />

                <div>

                    <h3>

                        Delivery Address

                    </h3>

                    <p>

                        {order.addressSnapshot
                            ?.fullName}

                    </p>

                    <p>

                        {order.addressSnapshot
                            ?.phone}

                    </p>

                    <p>

                        {order.addressSnapshot
                            ?.addressLine1}

                    </p>

                    {order.addressSnapshot
                        ?.addressLine2 && (

                        <p>

                            {order.addressSnapshot
                                .addressLine2}

                        </p>

                    )}

                    {order.addressSnapshot
                        ?.landmark && (

                        <p>

                            Landmark :

                            {" "}

                            {order.addressSnapshot
                                .landmark}

                        </p>

                    )}

                    <p>

                        {order.addressSnapshot
                            ?.city}

                        ,

                        {" "}

                        {order.addressSnapshot
                            ?.state}

                        {" "}

                        -

                        {" "}

                        {order.addressSnapshot
                            ?.pincode}

                    </p>

                </div>

            </div>

        </div>

    );

}

export default OrderHero;